import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { Platform } from "../../../../../shared/enums/campaignPost.enums";
import { TrackingService } from "../../../../../shared/analytics/tracking.service";
import { BrandCampaignService } from "../../../shared/services/brand-campaign.service";
import { BetaCampaignTrackingEvents } from "../../../shared/tracking/beta-campaign.tracking-events";
import { PublicationTemplateType } from "../../data/entities/publication-templates.entity";

@Component({
  selector: "app-publication-template-thumbnail",
  templateUrl: "./publication-template-thumbnail.component.html",
  styleUrl: "./publication-template-thumbnail.component.scss",
})
export class PublicationTemplateThumbnailComponent {
  @Input({ required: true }) protected platform!: Platform;
  @Input({ required: true }) protected type!: PublicationTemplateType;
  @Input({ required: true }) protected formRoute!: string;
  private readonly betaCampaignEvents: BetaCampaignTrackingEvents;

  constructor(
    private readonly router: Router,
    brandCampaignService: BrandCampaignService,
    trackingService: TrackingService,
  ) {
    this.betaCampaignEvents = new BetaCampaignTrackingEvents(
      brandCampaignService.currentBrandCampaignId,
      trackingService,
    );
  }

  protected async goToPublicationCreation(): Promise<void> {
    this.betaCampaignEvents.publicationTemplateTypeSelected(this.type);
    await this.router.navigateByUrl(this.formRoute);
  }
}
